import Vue from 'vue/dist/vue.esm.js';
import 'hooper/dist/hooper.css';
 import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter);

document.addEventListener('DOMContentLoaded', () => {
  let vm = new Vue({
    el: '#show',
    data: {},
  });
});
